import {
  ClusterOutlined,
  RightOutlined,
  SaveOutlined,
} from '@ant-design/icons';
import {
  Button,
  Card,
  Col,
  Collapse,
  Empty,
  Row,
  Skeleton,
  Space,
  Tooltip,
  Typography,
} from 'antd';

import type { AccessRightsListType } from '@pages/Users/AccessRightsTab/types';

import '@pages/Users/AccessRightsTab/styles/AccessRightsList.desktop.scss';

const { Text } = Typography;

export const AccessRightsList: AccessRightsListType = ({
  isAdmin,
  isLoading,
  isSaveLoading,
  isDesktop,
  hasChanges,
  unsavedAccessRights,
  showCreateTemplateButton,
  openCreateTemplateDialog,
  onSave,
  accordionList,
}) => {
  const span = isDesktop ? 12 : 24;
  const tooltipTitle = !hasChanges
    ? 'Для сохранения прав внесите, пожалуйста, какое-либо изменение в них'
    : null;

  const customExpandIcon = ({ isActive }: { isActive?: boolean }) => (
    <RightOutlined
      rotate={isActive ? 90 : 0}
      data-testid={isActive ? 'open-section' : 'close-section'}
      className="accordion-arrow"
    />
  );

  if (isLoading) {
    return <Skeleton active />;
  }

  if (isAdmin) {
    return (
      <Card>
        <Text>
          Пользователь имеет полные права доступа. Вы не можете изменить их.
        </Text>
      </Card>
    );
  }

  if (!unsavedAccessRights) {
    return (
      <Card>
        <Empty />
      </Card>
    );
  }

  return (
    <Space direction="vertical" style={{ maxWidth: 800, width: '100%' }}>
      <Collapse
        expandIconPosition="end"
        items={accordionList}
        size="large"
        expandIcon={customExpandIcon}
      />
      <Row gutter={16}>
        <Col span={span}>
          <Tooltip title={tooltipTitle}>
            <Button
              block
              disabled={!hasChanges || isSaveLoading}
              icon={<SaveOutlined />}
              size="large"
              type="primary"
              style={{ marginTop: 20 }}
              onClick={onSave}
              data-testid="save-rights"
            >
              Сохранить права
            </Button>
          </Tooltip>
        </Col>
        {showCreateTemplateButton && (
          <Col span={span}>
            <Button
              block
              icon={<ClusterOutlined />}
              size="large"
              style={{ marginTop: 20 }}
              onClick={openCreateTemplateDialog}
              data-testid="create-rights-template"
            >
              Создать шаблон прав
            </Button>
          </Col>
        )}
      </Row>
    </Space>
  );
};
